<template>
    <div class="index">

            <Footer v-if="show"></Footer>
            <keep-alive>
                <router-view  class="content" v-if="$route.meta.keepAlive"></router-view>
                
            </keep-alive>
            <router-view class="content" v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>

<script>
import Footer from "../components/footer";
    export default {
        components: {
            Footer,
        },
        name:'index',
        data () {
            return {
                show:true
            }
        },
        methods: {
           isFooter(){
                let route= this.$route.path;
                if(route.indexOf('/alarmDetails') === 0 || route.indexOf('/instruction') === 0 || route.indexOf('/fence') === 0 || route.indexOf('/fenceCreate') === 0 || route.indexOf('/inparticulars') === 0 || route.indexOf('/starting') === 0 || route.indexOf('/sos') === 0 || route.indexOf('/amendRail') === 0 || route.indexOf('/RailParticulars') === 0){
                        this.show = false;
                }else{
                        this.show = true;
                }
           } 
        },
        mounted () {
            this.isFooter()
        },
        watch: {
		 		'$route': function (newVal,oldVal) {
                    this.isFooter()
                 }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/index.vue